<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('AgencyLeads.title', { agencyName: agency.title }) }}
        <template #actions>
          <div :id="exportActionTargetId" />
        </template>
      </ContentCardSubheader>
    </template>
    <LeadsDataProvider :contactable-id="agency.globalId" :contactable-name="agency.title" context="agency" />
  </ContentCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { exportActionTargetId } from '@/components/ReviewsCommon/Leads/exportActionTarget'
import LeadsDataProvider from '@/components/ReviewsCommon/Leads/LeadsDataProvider.vue'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs'
import type { AgencyData } from '@/gql/reviews'
import { useRoleRedirect } from '@/services/roleRedirect'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{
  agency: AgencyData
}>()

useRoleRedirect('viewReviewsAgencyLeads')

const { t } = useI18n()
const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency)
</script>
